'use strict';

export function initiateApp() {
  window.fedops = window.fedops || {};
  window.fedops.apps = window.fedops.apps || {};
}



// WEBPACK FOOTER //
// ./app-initializer.js